import { useMemo } from 'react'
import { StepOption, StepOptions } from '@order/steps/types'
import { resolveTier } from '@order/steps/helpers'
import { Active, AttributeTiers } from './types'
import { AttributeConfig } from '@ca/common/types'

export const getFirstActive = (options: StepOption[]): Active | null => {
  const foundOption = options.find((option) => !!option.attributes) || null
  return foundOption ? { optionId: foundOption.id, activeIndex: 0 } : null
}

export const useOptionAttributesTiers = (
  options: StepOptions
): AttributeTiers => {
  const tiers = useMemo(() => {
    const record: AttributeTiers = {}

    options.forEach((option) => {
      const tier = resolveTier(option.value)
      option.attributes?.forEach((attribute) => {
        if (!record[attribute.name]) {
          record[attribute.name] = []
        }
        if (!record[attribute.name].includes(tier)) {
          record[attribute.name].push(tier)
        }
      })
    })

    return record
  }, [options])

  return tiers
}

export const useOptionsAttributes = (
  options: StepOptions
): AttributeConfig[] => {
  const attributes: AttributeConfig[] = useMemo(() => {
    const unique = new Map<string, AttributeConfig>()

    options.forEach((option) => {
      option.attributes?.forEach((attribute) => {
        unique.set(attribute.name, attribute)
      })
    })

    return Array.from(unique.values())
  }, [options])

  return attributes
}

export const useOptionAttributes = (option: StepOption): AttributeConfig[] => {
  const attributes = useOptionsAttributes([option])
  return attributes
}
